import React, { FC, useEffect } from 'react'
import GuideDrawer from '@common/GuideDrawer'
import { Empty, Spin } from 'hljd'
import style from './style.module.less'
import { useLocalStore, Observer } from 'mobx-react'
import Api from '@api/common/index'
/**
 * 根据运营后台配置指南id 展示指南信息
 * @author  Ta_Mu
 * @date 2021/5/25 17:18
 */
interface ISimpleGuide extends Partial<React.ComponentProps<typeof GuideDrawer>>{
  guideId: number // 运营后台配置的指南id， 注意使用的时候， 测试环境和预发/正式环境 指南id可能会变化，需要同步修改
  title?: string // 不传则会默认使用请求返回的title (新手指南的任务名称）
}

interface IStoreProps {
  loading: boolean
  content: string
  title: string
  getGuide: (guideId: number) => void
}
const SimpleGuide: FC<ISimpleGuide> = (props) => {

  const { guideId, title, ...rest } = props

  const store = useLocalStore<IStoreProps>(() => ({
    loading: true,
    content: null,
    title: null,
    getGuide: async (guideId) => {
      store.loading = true
      const {success, data} = await Api.getGuide(guideId)
      store.loading = false
      if(success) {
        store.content = data.content
        store.title = data.title
      }
    }
  }))

  useEffect(() => {
    store.getGuide(guideId)
  }, [guideId])

  return (
    <Observer>
      {
        () => (
          <GuideDrawer title={title || store.title} {...rest}>
            <Spin spinning={store.loading}>
              {
                store.content ?
                  <div
                    className={style.content}
                    style={{ padding: 20 }}
                    dangerouslySetInnerHTML={{ __html: store.content }}
                  />
                  :
                  <Empty style={{marginTop: 40}}/>
              }
            </Spin>
          </GuideDrawer>
        )
      }
    </Observer>
  )
}

export default SimpleGuide
